import React from 'react'
import { Link } from 'react-router-dom'
import StaticCmsPage, { StaticSection } from '../../components/nemonto/StaticCmsPage'

const AboutUs = () => (
    <StaticCmsPage slug="about" title="About Us" subtitle="Get to know the team and mission behind Nemonto.">
        <StaticSection heading="You're invited to the table">
            <p>
                Nemonto comes from a Bengali word for a dinner invitation. That's the idea behind everything we
                build: food is better when it's shared, and the best recipes are the ones other people actually cook.
            </p>
            <p>
                Nemonto is the social kitchen for people who love to cook. Post a recipe. Someone cooks it. They
                post their version back. One dish ends up with a whole community behind it, and that is more useful
                than any star rating.
            </p>
        </StaticSection>

        <StaticSection heading="How it works">
            <ol>
                <li>
                    <strong>Post your recipe.</strong> Add photos or a video, the ingredients, the steps, the cook
                    time and calories. It lands on the feed looking like a dinner invite, not a database entry.
                </li>
                <li>
                    <strong>Someone makes it.</strong> They tap "Made it?" and share how it turned out: nailed it,
                    almost, or their own twist. Every reply is a real cooking session, not just a comment.
                </li>
                <li>
                    <strong>The recipe grows.</strong> Each version adds tips, swaps and photos, so the next person
                    to cook it knows exactly what to expect.
                </li>
            </ol>
        </StaticSection>

        <StaticSection heading="What you can do on Nemonto">
            <ul>
                <li><strong>Discover</strong> real recipes from home cooks across cuisines, from Bengali and South Asian to Italian, Mexican, BBQ, French and East Asian.</li>
                <li><strong>Share</strong> recipes, posts and stories from your own kitchen.</li>
                <li><strong>Join challenges.</strong> Enter Nemonto Challenges and Shape Challenges, or host your own. Creators set the ingredients, cuisine and clock, and a real person picks the winner, not a like count. Winners earn a badge that stays on their profile.</li>
                <li><strong>Save favourites</strong> and build your own cookbook of recipes you want to make again.</li>
                <li><strong>Gather in groups.</strong> Group chats for family, friends and supper clubs to plan meals together.</li>
                <li><strong>Grow a following.</strong> Follow the cooks you like, connect with people who cook what you cook, and discover creators and influencers.</li>
                <li><strong>Promote your work.</strong> Creators and businesses can run ad posts to reach more of the community.</li>
            </ul>
        </StaticSection>

        <StaticSection heading="What we believe">
            <ul>
                <li><strong>Real food, made by real people.</strong> The feed is recipes and proof that someone else made them, not filters or kitchen-gadget ads.</li>
                <li><strong>People judge, not algorithms.</strong> Challenge winners are picked by the creator who hosts them.</li>
                <li><strong>Recognition belongs to the cook.</strong> Badges, credits and "made it" versions stay attached to the people who earned them.</li>
                <li><strong>Every table has a seat for everyone.</strong> Every cuisine, every skill level, every kitchen.</li>
            </ul>
        </StaticSection>

        <StaticSection heading="For creators">
            <p>
                We're launching city by city, starting in New York City. The first creators to join in each city become
                Founding Creators, with a permanent founding badge, free Pro access for life, first right to host
                challenges, and a spotlight on Nemonto's own channels.
            </p>
        </StaticSection>

        <StaticSection heading="Who we are">
            <p>
                Nemonto is powered by <a href="https://nemonto.com/" target="_blank" rel="noopener noreferrer">Syntch</a> and
                developed by <a href="https://www.debtechllc.com/" target="_blank" rel="noopener noreferrer">Debtech LLC</a>.
                It's available on the web and as an app for iOS and Android.
            </p>
            <p>
                Questions, feedback or partnership ideas? <Link to="/contact-us">Contact us</Link>. We'd love to hear from you.
            </p>
        </StaticSection>
    </StaticCmsPage>
)

export default AboutUs
